import { useAuth } from 'react-oidc-context';
import { isOidcConfigured } from '../lib/auth';

interface AuthUser {
  name: string;
  email: string;
  isAuthenticated: boolean;
}

/**
 * Extracts user profile info from the OIDC token.
 * Returns empty strings if OIDC is not configured (dev mode).
 */
export function useAuthUser(): AuthUser {
  if (!isOidcConfigured()) {
    return { name: '', email: '', isAuthenticated: false };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const auth = useAuth();

  if (!auth.isAuthenticated || !auth.user?.profile) {
    return { name: '', email: '', isAuthenticated: false };
  }

  const profile = auth.user.profile;

  return {
    name: (profile.name as string) || `${profile.given_name || ''} ${profile.family_name || ''}`.trim(),
    email: (profile.email as string) || '',
    isAuthenticated: true,
  };
}
